<template>

<com-item name="players.hindex" :has-more="true" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="H-index">

	<template v-slot:stats>

		<app-user type="player" :item="item" v-for="(item, index) in data.hindex" :subtext="item.plays + ' play' + ((item.plays > 1) ? 's' : '')" :key="index" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/hindex']

		},

		active: function() {

			return this.data.hindex.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersHindex'
			})
		
		}

	}

}

</script>

<style scoped>

</style>